import { useLocalization } from '@magicdoorinc/ui';

const { t } = useLocalization();

export type FilterValue = Record<string, any>;

export type Config = {
  multiple?: boolean;
};

export const allOption = () => ({ label: t('All'), value: undefined });
